module.exports = __webpack_public_path__ + "static/media/landing-activities.71215689.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/landing-activities.png
// module id = 579
// module chunks = 0